'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = info;
exports.isLoaded = isLoaded;
exports.loadGoals = loadGoals;
exports.updateGoals = updateGoals;
exports.loadBarriers = loadBarriers;
exports.updateBarriers = updateBarriers;
exports.loadStrategies = loadStrategies;
exports.updateStrategies = updateStrategies;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_GOALS = 'LOAD_GOALS';
var LOAD_GOALS_SUCCESS = 'LOAD_GOALS_SUCCESS';
var LOAD_GOALS_FAIL = 'LOAD_GOALS_FAIL';
var UPDATE_GOALS = 'UPDATE_GOALS';
var UPDATE_GOALS_SUCCESS = 'UPDATE_GOALS_SUCCESS';
var UPDATE_GOALS_FAIL = 'UPDATE_GOALS_FAIL';

var LOAD_BARRIERS = 'LOAD_BARRIERS';
var LOAD_BARRIERS_SUCCESS = 'LOAD_BARRIERS_SUCCESS';
var LOAD_BARRIERS_FAIL = 'LOAD_BARRIERS_FAIL';

var UPDATE_STRATEGY = 'UPDATE_STRATEGY';

var initialState = {
  loaded: false
};

function info() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATE_STRATEGY:
      return (0, _extends3.default)({}, state, {
        data: (0, _extends3.default)({}, state.data, {
          strategies: action.data.state
        })
      });
    case UPDATE_GOALS:
    case LOAD_GOALS:
    case LOAD_BARRIERS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });

    case UPDATE_GOALS_SUCCESS:
    case LOAD_GOALS_SUCCESS:
    case LOAD_BARRIERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: (0, _extends3.default)({}, state.data, action.result)
      });
    case UPDATE_GOALS_FAIL:
    case LOAD_GOALS_FAIL:
    case LOAD_BARRIERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.goals && globalState.goals.loaded;
}

function loadGoals(userId) {
  return {
    types: [LOAD_GOALS, LOAD_GOALS_SUCCESS, LOAD_GOALS_FAIL],
    promise: function promise(client) {
      return client.get('/goals/load', {
        params: {
          userId: userId
        }
      });
    }
  };
}

function updateGoals(userId, state) {
  return {
    types: [UPDATE_GOALS, UPDATE_GOALS_SUCCESS, UPDATE_GOALS_FAIL],
    promise: function promise(client) {
      return client.post('/goals/update', {
        data: {
          userId: userId,
          state: state
        }
      });
    }
  };
}

function loadBarriers(userId) {
  var url = '/goals/barriers/load';
  return {
    types: [LOAD_BARRIERS, LOAD_BARRIERS_SUCCESS, LOAD_BARRIERS_FAIL],
    promise: function promise(client) {
      return client.get(url, {
        params: {
          userId: userId
        }
      });
    }
  };
}

function updateBarriers(userId, state) {
  console.log('update bar state');
  console.log(state);
  return {
    types: [UPDATE_GOALS, UPDATE_GOALS_SUCCESS, UPDATE_GOALS_FAIL],
    promise: function promise(client) {
      return client.post('/goals/barriers/update', {
        data: {
          userId: userId,
          state: state
        }
      });
    }
  };
}

function loadStrategies(userId) {
  var url = '/goals/strategies/load';
  return {
    types: [LOAD_BARRIERS, LOAD_BARRIERS_SUCCESS, LOAD_BARRIERS_FAIL],
    promise: function promise(client) {
      return client.get(url, {
        params: {
          userId: userId
        }
      });
    }
  };
}

function updateStrategies(userId, state) {
  console.log('update strat state');
  console.log(state);
  return {
    types: [UPDATE_GOALS, UPDATE_GOALS_SUCCESS, UPDATE_GOALS_FAIL],
    promise: function promise(client) {
      return client.post('/goals/strategies/update', {
        data: {
          userId: userId,
          state: state
        }
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/goals.js
// module id = 57
// module chunks = 0